"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var event_emitter_1 = require("../utils/event-emitter");
var wix_duplexer_protocol_1 = require("@wix/wix-duplexer-protocol");
var Channel = /** @class */ (function (_super) {
    __extends(Channel, _super);
    function Channel(virtualSocket, name, resourceId, info) {
        var _this = _super.call(this) || this;
        _this.subscribingState = 1 /* SubscribingState.UNSUBSCRIBED */;
        _this.name = name;
        _this.virtualSocket = virtualSocket;
        _this.resourceId = resourceId;
        _this.info = info;
        return _this;
    }
    Channel.prototype.setMessageIdRestore = function (messageId) {
        this.restore = wix_duplexer_protocol_1.RestoreStrategyBuilderFactory.messageId()
            .withId(messageId)
            .build();
        return this.restore;
    };
    Channel.prototype.subscribe = function (opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.subscribingState === 0 /* SubscribingState.SUBSCRIBED */) {
                            setTimeout(function () { return _this.emitSubscriptionSucceeded(true); }, 0);
                            return [2 /*return*/];
                        }
                        if (this.subscribingState === 2 /* SubscribingState.SUBSCRIBING */) {
                            return [2 /*return*/];
                        }
                        this.subscribingState = 2 /* SubscribingState.SUBSCRIBING */;
                        return [4 /*yield*/, this.sendSubscribe(opts)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.setUnsubscribe = function () {
        this.subscribingState = 1 /* SubscribingState.UNSUBSCRIBED */;
    };
    Channel.prototype.sendSubscribe = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.virtualSocket.send({
                            type: 'subscribe',
                            channel: this.name,
                            resourceId: this.resourceId,
                            auth: '',
                            restore: opts.restoreStrategy || this.restore,
                            info: this.info,
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.type === 'error') {
                            this.emit('@duplexer:subscription_failed', res);
                        }
                        else {
                            this.subscribingState = 0 /* SubscribingState.SUBSCRIBED */;
                            this.emitSubscriptionSucceeded(res.isSynced);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.unsubscribe = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.virtualSocket.send({
                            type: 'unsubscribe',
                            channel: this.name,
                            resourceId: this.resourceId,
                        })];
                    case 1:
                        _a.sent();
                        this.subscribingState = 1 /* SubscribingState.UNSUBSCRIBED */;
                        this.emit('@duplexer:unsubscribe_succeeded');
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.send = function (event, payload) {
        return this.virtualSocket.send({
            type: 'client_message',
            channel: this.name,
            resourceId: this.resourceId,
            event: event,
            payload: payload,
        }, { affectState: false });
    };
    Channel.prototype.emitSubscriptionSucceeded = function (isSynced) {
        this.emit('@duplexer:subscription_succeeded', { isSynced: isSynced });
    };
    return Channel;
}(event_emitter_1.Emitter));
exports.default = Channel;
//# sourceMappingURL=channel.js.map